import React from 'react';
import { Shield, Bell, Globe, User } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { useAuth } from '../contexts/AuthContext';

export default function SettingsPage() {
  const { user } = useAuth();

  return (
    <div className="p-6 space-y-6" data-testid="settings-page">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Settings</h1>
        <p className="text-sm text-gray-500 mt-1">System configuration and preferences</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Account */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <User className="w-4 h-4 text-indigo-600" />
              Account
            </CardTitle>
            <CardDescription>Your admin account details</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Name</span>
              <span className="font-medium">{user?.name || '-'}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Email</span>
              <span className="font-medium">{user?.email || '-'}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Role</span>
              <span className="font-medium capitalize">{user?.role || '-'}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Auth Provider</span>
              <span className="font-medium capitalize">{user?.auth_provider || 'Local'}</span>
            </div>
          </CardContent>
        </Card>

        {/* Security */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <Shield className="w-4 h-4 text-emerald-600" />
              Security
            </CardTitle>
            <CardDescription>Access control settings</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Two-Factor Auth</span>
              <span className="text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-600">Coming Soon</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Session Duration</span>
              <span className="font-medium">24 hours</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Brute Force Protection</span>
              <span className="text-emerald-600 font-medium">Enabled</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Lockout Threshold</span>
              <span className="font-medium">5 failed attempts</span>
            </div>
          </CardContent>
        </Card>

        {/* Notifications */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <Bell className="w-4 h-4 text-amber-600" />
              Notifications
            </CardTitle>
            <CardDescription>Alert and notification preferences</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Email Alerts</span>
              <span className="text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-600">Coming Soon</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Crossing Notifications</span>
              <span className="text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-600">Coming Soon</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Buffer Alerts</span>
              <span className="text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-600">Coming Soon</span>
            </div>
          </CardContent>
        </Card>

        {/* System */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <Globe className="w-4 h-4 text-sky-600" />
              System
            </CardTitle>
            <CardDescription>Platform configuration</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Timezone</span>
              <span className="font-medium">Australia/Melbourne (AEST)</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Currency</span>
              <span className="font-medium">AUD ($)</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Data Refresh</span>
              <span className="font-medium">Every 30 seconds</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Version</span>
              <span className="font-mono text-xs text-gray-400">trove helix. v1.0.0</span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
